export const appLocalStorageNames = {
    authStore: "tb-auth-store",
    cisPersistStore: "tb-cis-persist-store",
    companyPersistStore: "tb-company-persist-store",
    containerPersistStore: "tb-container-persist-store",
    devStore: "tb-dev-store",
    logger: "tb-logger"
};
